import * as GeneralSelectionActions from './../../general-selection/actions/general-selection.actions';
import * as systemActions from 'src/app/store/system/actions/system.actions';
import * as TradingActions from '../actions/trading.actions';
import { initialTradingState, ITradingState } from '../../state/order.state';

export function TradingReducer(state = initialTradingState, action: TradingActions.TradingActions | systemActions.SystemActions | GeneralSelectionActions.GeneralSelectionActions): ITradingState {
    switch (action.type) {
      case TradingActions.GET_CURRENT_ORDERS_LIST_SUCCESS: {
        return {
          ...state,
          orders: action.payload,
          loading: false
        };
      }
      case TradingActions.GET_PRODUCTS_LIST:
      case TradingActions.GET_CURRENT_ORDERS_LIST: {
        return {
          ...state,
          loading: true
        };
      }
      case TradingActions.GET_PRODUCTS_LIST_SUCCESS: {
        return {
          ...state,
          products: action.payload,
          loading: false
        };
      }
      case TradingActions.UPDATE_STATUS: {
        return {
          ...state,
          loading: false
        };
      }
      case TradingActions.GET_REGULAR_INVESTMENT_PLAN_SUCCESS: {
        return {
          ...state,
          investmentPlan: action.payload
        };
      }
      case TradingActions.GET_REGULAR_INVESTMENT_PLAN_NOT_FOUND: {
        return {
          ...state,
          investmentPlan: {} // we set the investmentPlan to an empty object to use in KiwiSaverRedirectService (investmentPlan$)
        };
      }
      case systemActions.CLEAR_SYSTEM:
      case GeneralSelectionActions.UPDATE_SELECTION: {
        return {
          ...initialTradingState
        };
      }

      default:
        return state;
    }
}
